var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadingButton',{staticClass:"submit-button",attrs:{"type":"primary","disabled":_vm.disabled,"loading":_vm.loading,"color-range":_vm.getColorRange},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }